import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Dropdown,
  DropdownButton,
  Card,
  Row,
  Col,
  Container,
  Spinner,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Edityourblogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [selectedCategory, setSelectedCategory] = useState(""); // State for category filter
  const [categories, setCategories] = useState([]); // State for categories
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("https://blog-backend-ivfv.onrender.com/blogs");
        setBlogs(response.data);

        // Extract unique categories from blogs data once
        const uniqueCategories = [
          ...new Set(response.data.map((blog) => blog.category)),
        ];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Error fetching blogs data:", error);
        setError("Error fetching blogs data. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://blog-backend-ivfv.onrender.com/blogs/${id}`);
      setBlogs((prevBlogs) => prevBlogs.filter((blog) => blog._id !== id));
      toast.success("Successfully deleted");
    } catch (error) {
      console.error("Error deleting blog:", error.response);
      setError("Error deleting blog. Please try again later.");
    }
  };

  // Memoize filtered blogs to prevent recalculating on every render
  const filteredBlogs = useMemo(() => {
    return blogs.filter((blog) => {
      const matchesSearchQuery =
        blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        blog.summary.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory
        ? blog.category === selectedCategory
        : true;
      return matchesSearchQuery && matchesCategory;
    });
  }, [blogs, searchQuery, selectedCategory]);

  if (loading) {
    return (
      <Container className="text-center">
        <Spinner animation="border" variant="primary" />
        <p>Loading blogs...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="text-center">
        <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>
      </Container>
    );
  }

  return (
    <Container className="editSection">
      <ToastContainer />
      <h1 className="my-4 text-center">Blog List</h1>
      <div className="d-flex mx-2">
        {/* Search Bar */}
        <Form.Control
          type="text"
          placeholder="Search by title "
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="mb-4 w-50 mx-auto"
        />

        {/* Category Filter */}
        <DropdownButton
          id="category-filter"
          title={selectedCategory || "Search by Category"}
          onSelect={(category) => setSelectedCategory(category)}
          className="mb-4 w-50 mx-5 mt-1"
        >
          <Dropdown.Item eventKey="">All Categories</Dropdown.Item>
          {categories.map((category, index) => (
            <Dropdown.Item key={index} eventKey={category}>
              {category}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>

      <Row>
        {filteredBlogs.map((blog, index) => (
          <Col key={blog._id} xs={12} className="mb-3">
            <div className="d-flex align-items-center border p-3 rounded shadow-sm bg-white">
              {/* Serial Number */}
              <div className="me-3 fw-bold text-secondary" style={{ width: "30px", textAlign: "center" }}>
                {index + 1}.
              </div>

              {/* Thumbnail */}
              <img
                src={`https://blog-backend-ivfv.onrender.com/${blog.thumbnail}`}
                alt={blog.title}
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                }}
              />

              {/* Blog Info */}
              <div className="flex-grow-1 mx-3">
                <h5 className="mb-1 text-dark" style={{ fontWeight: "600" }}>
                  {blog.title.split(" ").slice(0, 4).join(" ")}
                  <br />
                  {blog.title.split(" ").slice(4).join(" ")}
                </h5>

                <p className="mb-0 text-muted" style={{ fontSize: "0.9rem", lineHeight: "1.3" }}>
                  {blog.summary}
                </p>
              </div>

              {/* Action Buttons */}
              <div className="text-end">
                <Link className="mx-2" to={`/editblog/${blog._id}`}>

                  Edit
                </Link>
                <Button variant="danger" onClick={() => handleDelete(blog._id)}>
                  Delete
                </Button>
              </div>
            </div>
          </Col>
        ))}
      </Row>

    </Container>
  );
};

export default Edityourblogs;
